// Centralized translation dictionaries (RU, EN, KY)
// Domain-based grouping for clarity.

export const dictionaries = {
  ru: {
    // Navigation & layout
    nav: {
      home: 'Главная',
      catalog: 'Каталог',
      cart: 'Корзина',
      checkout: 'Оформление',
      profile: 'Профиль',
      login: 'Войти',
      logout: 'Выйти',
      register: 'Регистрация',
      b2b: 'B2B Кабинет',
      admin: 'Админ',
      language: 'Язык',
      setConfigurator: 'Собрать комплект',
    },
    // Auth
    auth: {
      email: 'Email',
      password: 'Пароль',
      rememberMe: 'Запомнить меня',
      forgotPassword: 'Забыли пароль?',
      demoAccess: 'Демо доступ',
      signIn: 'Войти',
      signUp: 'Создать аккаунт',
      haveAccount: 'Уже есть аккаунт? Войти',
      noAccount: 'Нет аккаунта? Зарегистрируйтесь',
      name: 'Имя',
      lastName: 'Фамилия',
      passwordConfirm: 'Подтвердите пароль',
      registering: 'Регистрация...',
      loggingIn: 'Вход...',
      logoutSuccess: 'Вы вышли',
      registerSuccess: 'Регистрация успешна',
      registerSuccessRedirect: 'Успешно! Перенаправление...',
      useDemoOrCreds: 'Используйте демо-аккаунт или свои учетные данные.',
      demoUser: 'Демо пользователь',
      demoB2B: 'Демо B2B',
      demoAdmin: 'Демо Админ',
      loginSuccess: 'Успешный вход',
      roleHelp:
        'После входа роли: User → базовый, B2B → расширенные цены, Admin → административный доступ.',
      allRequired: 'Все поля обязательны',
      emailInvalid: 'Неверный формат email',
      passwordTooShort: 'Пароль слишком короткий',
      passwordsMismatch: 'Пароли не совпадают',
      registerError: 'Ошибка регистрации',
      createAccountHelp: 'Создайте аккаунт для оформления заказов.',
    },
    roles: {
      role_admin: 'Администратор',
      role_b2c_customer: 'Покупатель',
      role_b2b_candidate: 'Заявка B2B',
      role_b2b_verified: 'B2B Клиент',
      role_guest: 'Гость',
    },
    product: {
      addToCart: 'В корзину',
      outOfStock: 'Нет в наличии',
      inStock: 'В наличии',
      lowStock: 'Мало',
      available: 'доступно',
      reviews: 'Отзывы',
      rating: 'Рейтинг',
      writeReview: 'Оставить отзыв',
      cancel: 'Отмена',
      submit: 'Отправить',
      buyNowShort: 'Купить',
      addShort: 'В корзину',
      addLong: 'Добавить в корзину',
      quickView: 'Быстрый просмотр',
      addFavorite: 'Добавить в избранное',
      removeFavorite: 'Удалить из избранного',
      share: 'Поделиться',
      rateProduct: 'Оценить товар',
      yourRating: 'Ваша оценка:',
      commentLabel: 'Ваш комментарий (необязательно)',
      commentPlaceholder: 'Поделитесь своим мнением о товаре...',
      relatedProducts: 'С этим товаром смотрят',
      submitting: 'Отправка...',
      reviewSuccess: 'Спасибо за ваш отзыв!',
      reviewError: 'Не удалось отправить отзыв. Попробуйте позже.',
      loginRequired: 'Войдите в аккаунт, чтобы оставить отзыв',
      b2bMode: '🏢 B2B Режим - Специальные цены и условия для бизнеса',
      b2bPending:
        '⏳ Ваша заявка на B2B статус рассматривается. Мы свяжемся с вами в ближайшее время.',
      recentlyViewed: 'Недавно просмотренные',
      clearHistory: 'Очистить историю',
    },
    productMocks: {
      executiveChair: {
        name: 'Эргономичное кресло для руководителя',
        desc: 'Премиальное кресло с ортопедической поддержкой для длительной работы',
      },
      standingDesk: {
        name: 'Регулируемый стол для работы стоя',
        desc: 'Инновационный стол с электрической регулировкой высоты',
      },
      modularSofa: {
        name: 'Модульный диван для переговорных',
        desc: 'Стильный модульный диван для современных офисных пространств',
      },
      conferenceTable: {
        name: 'Конференц-стол на 12 персон',
        desc: 'Большой овальный стол для конференц-зала с кабель-менеджментом',
      },
      ergonomicChair: {
        name: 'Эргономичное рабочее кресло',
        desc: 'Комфортное кресло с сетчатой спинкой для ежедневной работы',
      },
      mobileCabinet: {
        name: 'Мобильная тумба с замком',
        desc: 'Компактная тумба на колесиках для рабочего места',
      },
    },
    cart: {
      title: 'Корзина',
      empty: 'Корзина пуста',
      total: 'Итого',
      proceed: 'Перейти к оформлению',
      quantity: 'Количество',
      goShopping: 'Перейти к покупкам',
      emptyTitle: 'Ваша корзина пуста',
      emptySubtitle: 'Добавьте товары в корзину, чтобы оформить заказ',
      orderSummary: 'Итого по заказу',
      itemsInCart: 'Товары в корзине',
      promoCode: 'Промокод',
      enterCode: 'Введите код',
      apply: 'Применить',
      applied: 'Применен',
      discount10: '✓ Промокод применен: скидка 10%',
      products: 'Товары',
      shipping: 'Доставка',
      free: 'Бесплатно',
      clear: 'Очистить корзину',
      itemTotal: 'Итого',
      checkout: 'Оформить заказ',
      loginAndCheckout: 'Войти и оформить',
      continue: 'Продолжить покупки',
      safePayment: 'Безопасная оплата',
      fastDelivery: 'Быстрая доставка',
      variousPayments: 'Различные способы оплаты',
      freeShippingThreshold: '🚚 Бесплатная доставка при заказе от 50,000 с',
    },
    checkout: {
      title: 'Оформление заказа',
      placeOrder: 'Разместить заказ',
      summary: 'Сводка заказа',
      steps: {
        shipping: 'Доставка',
        payment: 'Оплата',
        confirmation: 'Подтверждение',
      },
      shippingInfo: 'Информация о доставке',
      paymentMethod: 'Способ оплаты',
      orderConfirmation: 'Подтверждение заказа',
      shippingAddress: 'Адрес доставки',
      productsInOrder: 'Товары в заказе',
      address: 'Адрес',
      city: 'Город',
      phone: 'Телефон',
      firstName: 'Имя',
      lastName: 'Фамилия',
      email: 'Email',
      region: 'Регион',
      next: 'Далее',
      back: 'Назад',
      submitOrder: 'Оформить заказ',
      subtotal: 'Подытог',
      shipping: 'Доставка',
      total: 'Итого',
      quantity: 'Количество',
      validation: {
        fillFields: 'Пожалуйста, заполните: {{fields}}',
        phoneFormat: 'Номер телефона должен быть в формате +996XXXXXXXXX',
        selectRegion: 'Пожалуйста, выберите регион доставки',
        selectPayment: 'Пожалуйста, выберите способ оплаты',
      },
      errors: {
        orderCreate: 'Произошла ошибка при создании заказа',
      },
      yourOrder: 'Ваш заказ',
    },
    catalog: {
      title: 'Каталог мебели',
      titleB2B: 'B2B Каталог мебели',
      b2bInfo: '🏢 Специальные B2B цены и условия доставки',
      foundCount: '{{count}} товаров найдено',
      foundCountPlural: {
        one: '{{count}} товар найден',
        few: '{{count}} товара найдено',
        many: '{{count}} товаров найдено',
        other: '{{count}} товаров найдено',
      },
      searchPlaceholder: 'Поиск товаров...',
      sort: 'Сортировка',
      sortName: 'По названию',
      sortPriceAsc: 'Цена: по возрастанию',
      sortPriceDesc: 'Цена: по убыванию',
      filters: 'Фильтры',
      filtersCount: 'Фильтры ({{count}})',
      reset: 'Сбросить',
      categories: 'Категории',
      categoryLabels: {
        vanities: 'Тумбы для ванной',
        cabinets: 'Пеналы',
        'mirror-cabinets': 'Зеркальные шкафы',
        'led-mirrors': 'LED зеркала',
        mirrors: 'Зеркала',
        bathtubs: 'Ванны',
        showers: 'Душевые кабины',
        toilets: 'Унитазы',
        sinks: 'Раковины',
        faucets: 'Смесители',
        'water-heaters': 'Водонагреватели',
      },
      price: 'Цена (сом)',
      availability: 'Наличие',
      onlyInStock: 'Только в наличии',
      notFoundTitle: 'Товары не найдены',
      notFoundSubtitle: 'Попробуйте изменить параметры поиска или фильтры',
      apply: 'Применить',
      products: 'Товары',
    },
    // Навигация по комнатам
    rooms: {
      sectionTitle: 'Подберите мебель по типу помещения',
      sectionSubtitle:
        'Выберите комнату и найдите идеальное решение для вашего интерьера',
      filterTitle: 'Тип помещения',
      clearFilter: 'Сбросить',
      bathroom: {
        title: 'Ванная комната',
        short: 'Ванная',
        description: 'Тумбы, зеркала, душевые, ванны и аксессуары',
      },
      toilet: {
        title: 'Туалет',
        short: 'Туалет',
        description: 'Унитазы, раковины и компактная мебель',
      },
      combined: {
        title: 'Совмещённый санузел',
        short: 'Совмещённый',
        description: 'Полный комплект для совмещённого санузла',
      },
    },
    // Конфигуратор комплектов
    setConfigurator: {
      title: 'Собери свой комплект',
      subtitle:
        'Выберите тумбу, раковину и зеркало — получите скидку на весь комплект!',
      discountBanner:
        'Скидка {{discount}}% при покупке комплекта от 2-х товаров!',
      steps: {
        vanity: 'Тумба',
        sink: 'Раковина',
        mirror: 'Зеркало',
      },
      stepHints: {
        vanity: 'Выберите тумбу для ванной — основу вашего комплекта',
        sink: 'Добавьте раковину, которая подходит к тумбе',
        mirror: 'Завершите образ стильным зеркалом или зеркальным шкафом',
      },
      optional: '(опционально)',
      yourSet: 'Ваш комплект',
      notSelected: 'Не выбрано',
      subtotal: 'Сумма',
      discount: 'Скидка',
      total: 'Итого',
      youSave: 'Вы экономите {{amount}} сом',
      addSetToCart: 'Добавить комплект в корзину',
      addedToCart: 'Комплект добавлен в корзину!',
      goToCart: 'Перейти в корзину',
      createAnother: 'Собрать ещё один',
      reset: 'Сбросить выбор',
      back: 'Назад',
      next: 'Далее',
      noProducts: 'Товары в данной категории пока недоступны',
    },
    common: {
      loading: 'Загрузка...',
      error: 'Ошибка',
      save: 'Сохранить',
      close: 'Закрыть',
    },
    header: {
      profile: 'Профиль',
      myOrders: 'Мои заказы',
      applyB2B: 'Подать заявку на B2B',
      register: 'Регистрация',
    },
    footer: {
      catalog: 'Каталог',
      company: 'Компания',
      support: 'Поддержка',
      livingRoom: 'Гостиная',
      bedroom: 'Спальня',
      kitchen: 'Кухня',
      office: 'Офис',
      allProducts: 'Все товары',
      about: 'О компании',
      delivery: 'Доставка и оплата',
      warranty: 'Гарантия',
      contacts: 'Контакты',
      b2bCoop: 'B2B сотрудничество',
      help: 'Помощь покупателям',
      returns: 'Возврат товара',
      privacy: 'Политика конфиденциальности',
      terms: 'Пользовательское соглашение',
      faq: 'FAQ',
      businessBlock:
        'Премиальная мебель для дома и бизнеса. Работаем с частными клиентами и предоставляем специальные условия для B2B партнеров.',
      b2bPitch:
        '🏢 Для бизнеса: Специальные цены, отсрочка платежа, персональный менеджер.',
      b2bApply: 'Подать заявку на B2B статус',
      hours: 'Работаем с 9:00 до 21:00',
      noDaysOff: 'Без выходных',
      rights: '© 2024 Furniture Excellence. Все права защищены.',
    },
    home: {
      welcomeChip: 'Добро пожаловать, {{name}}!',
      hero: {
        b2b: {
          title: 'Добро пожаловать в B2B портал',
          subtitle: 'Специальные цены и условия для вашего бизнеса',
          primary: 'Перейти в B2B каталог',
          secondary: 'Быстрый заказ',
        },
        candidate: {
          title: 'Ваша заявка на рассмотрении',
          subtitle:
            'Пока рассматривается ваша B2B заявка, вы можете пользоваться обычным каталогом',
          primary: 'Посмотреть каталог',
          secondary: 'Мой профиль',
        },
        default: {
          title: 'Премиальная мебель для дома и офиса',
          subtitle:
            'Откройте для себя коллекцию стильной и качественной мебели. Специальные условия для бизнеса.',
          primary: 'Посмотреть каталог',
          secondary: 'B2B сотрудничество',
        },
      },
      features: {
        sectionTitle: {
          b2b: 'Преимущества B2B работы',
          default: 'Почему выбирают нас',
        },
        sectionSubtitle: {
          b2b: 'Эксклюзивные условия и сервис для наших бизнес-партнеров',
          default: 'Мы создаем исключительный опыт покупки мебели',
        },
        b2b: {
          pricing: {
            title: 'Специальные B2B цены',
            desc: 'Эксклюзивные скидки и оптовые цены для вашего бизнеса',
          },
          fastOrder: {
            title: 'Быстрый заказ по артикулам',
            desc: 'Оформите заказ за минуты с помощью SKU или списков',
          },
          manager: {
            title: 'Персональный менеджер',
            desc: 'Индивидуальный подход и поддержка на всех этапах',
          },
          delivery: {
            title: 'Гибкие условия доставки',
            desc: 'Доставка на несколько адресов, удобные сроки',
          },
        },
        default: {
          quality: {
            title: 'Премиум качество',
            desc: 'Только лучшие материалы и проверенные производители',
          },
          delivery: {
            title: 'Быстрая доставка',
            desc: 'Доставим ваш заказ в удобное время по всей стране',
          },
          warranty: {
            title: 'Гарантия качества',
            desc: 'Расширенная гарантия и возможность возврата',
          },
          support: {
            title: 'Поддержка 24/7',
            desc: 'Наши консультанты всегда готовы помочь',
          },
        },
      },
      cta: {
        title: 'Работаете с мебелью?',
        subtitle:
          'Получите доступ к специальным B2B ценам, персональному менеджеру и эксклюзивным условиям сотрудничества',
        buttonAuthenticated: 'Подать заявку на B2B',
        buttonGuest: 'Зарегистрироваться',
      },
      stats: {
        title: 'Ваши возможности',
        discount: {
          title: 'Скидка на весь каталог',
          desc: 'Ваш текущий уровень: {{tier}}',
          more: 'Подробнее',
        },
        terms: {
          title: 'Отсрочка платежа',
          desc: 'Гибкие условия оплаты',
          settings: 'Настройки',
        },
        support: {
          title: 'Поддержка',
          desc: 'Персональный менеджер',
          contact: 'Связаться',
        },
      },
    },
    rates: {
      updatedAt: 'Курс на {{date}}',
      refresh: 'Обновить',
      refreshing: 'Обновление...',
      error: 'Ошибка загрузки курсов',
      stale: 'Данные устарели',
      official: 'Официальные курсы НБКР',
    },
  },
  en: {
    nav: {
      home: 'Home',
      catalog: 'Catalog',
      cart: 'Cart',
      checkout: 'Checkout',
      profile: 'Profile',
      login: 'Login',
      logout: 'Logout',
      register: 'Register',
      b2b: 'B2B Portal',
      admin: 'Admin',
      language: 'Language',
      setConfigurator: 'Build a Set',
    },
    auth: {
      email: 'Email',
      password: 'Password',
      rememberMe: 'Remember me',
      forgotPassword: 'Forgot password?',
      demoAccess: 'Demo Access',
      signIn: 'Sign In',
      signUp: 'Create Account',
      haveAccount: 'Have an account? Sign in',
      noAccount: 'No account? Register',
      name: 'Name',
      lastName: 'Last name',
      passwordConfirm: 'Confirm Password',
      registering: 'Registering...',
      loggingIn: 'Signing in...',
      logoutSuccess: 'Logged out',
      registerSuccess: 'Registration successful',
      registerSuccessRedirect: 'Success! Redirecting...',
      useDemoOrCreds: 'Use a demo account or your credentials.',
      demoUser: 'Demo User',
      demoB2B: 'Demo B2B',
      demoAdmin: 'Demo Admin',
      loginSuccess: 'Login successful',
      roleHelp:
        'After login: User → basic, B2B → extended pricing, Admin → full access.',
      allRequired: 'All fields are required',
      emailInvalid: 'Invalid email format',
      passwordTooShort: 'Password too short',
      passwordsMismatch: 'Passwords do not match',
      registerError: 'Registration error',
      createAccountHelp: 'Create an account to place orders.',
    },
    roles: {
      role_admin: 'Admin',
      role_b2c_customer: 'Customer',
      role_b2b_candidate: 'B2B Pending',
      role_b2b_verified: 'B2B Client',
      role_guest: 'Guest',
    },
    product: {
      addToCart: 'Add to Cart',
      outOfStock: 'Out of stock',
      inStock: 'In stock',
      lowStock: 'Low',
      available: 'available',
      reviews: 'Reviews',
      rating: 'Rating',
      writeReview: 'Write a review',
      cancel: 'Cancel',
      submit: 'Submit',
      submitting: 'Submitting...',
      reviewSuccess: 'Thank you for your review!',
      reviewError: 'Failed to submit review. Please try again later.',
      loginRequired: 'Please log in to leave a review',
      buyNowShort: 'Buy',
      addShort: 'Cart',
      addLong: 'Add to Cart',
      quickView: 'Quick view',
      addFavorite: 'Add to favorites',
      removeFavorite: 'Remove from favorites',
      share: 'Share',
      rateProduct: 'Rate product',
      yourRating: 'Your rating:',
      commentLabel: 'Your comment (optional)',
      commentPlaceholder: 'Share your opinion about the product...',
      relatedProducts: 'Customers also viewed',
      b2bMode: '🏢 B2B Mode - Special pricing & terms for business',
      b2bPending:
        '⏳ Your B2B application is under review. We will contact you soon.',
      recentlyViewed: 'Recently Viewed',
      clearHistory: 'Clear history',
    },
    productMocks: {
      executiveChair: {
        name: 'Executive ergonomic chair',
        desc: 'Premium chair with orthopedic support for long sessions',
      },
      standingDesk: {
        name: 'Adjustable standing desk',
        desc: 'Innovative desk with electric height adjustment',
      },
      modularSofa: {
        name: 'Modular meeting sofa',
        desc: 'Stylish modular sofa for modern office spaces',
      },
      conferenceTable: {
        name: '12-person conference table',
        desc: 'Large oval conference table with cable management',
      },
      ergonomicChair: {
        name: 'Ergonomic work chair',
        desc: 'Comfortable mesh-back chair for everyday use',
      },
      mobileCabinet: {
        name: 'Mobile locking cabinet',
        desc: 'Compact rolling pedestal for workstation storage',
      },
    },
    cart: {
      title: 'Cart',
      empty: 'Cart is empty',
      total: 'Total',
      proceed: 'Proceed to Checkout',
      quantity: 'Quantity',
      goShopping: 'Go shopping',
      emptyTitle: 'Your cart is empty',
      emptySubtitle: 'Add products to proceed with checkout',
      orderSummary: 'Order Summary',
      itemsInCart: 'Items in cart',
      promoCode: 'Promo Code',
      enterCode: 'Enter code',
      apply: 'Apply',
      applied: 'Applied',
      discount10: '✓ Promo applied: 10% discount',
      products: 'Products',
      shipping: 'Shipping',
      free: 'Free',
      clear: 'Clear cart',
      itemTotal: 'Subtotal',
      checkout: 'Checkout',
      loginAndCheckout: 'Login & Checkout',
      continue: 'Continue shopping',
      safePayment: 'Secure payment',
      fastDelivery: 'Fast delivery',
      variousPayments: 'Multiple payment methods',
      freeShippingThreshold: '🚚 Free shipping over 50,000',
    },
    checkout: {
      title: 'Checkout',
      placeOrder: 'Place Order',
      summary: 'Order Summary',
      steps: {
        shipping: 'Shipping',
        payment: 'Payment',
        confirmation: 'Confirmation',
      },
      shippingInfo: 'Shipping Information',
      paymentMethod: 'Payment Method',
      orderConfirmation: 'Order Confirmation',
      shippingAddress: 'Shipping Address',
      productsInOrder: 'Items in Order',
      address: 'Address',
      city: 'City',
      phone: 'Phone',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      region: 'Region',
      next: 'Next',
      back: 'Back',
      submitOrder: 'Place Order',
      subtotal: 'Subtotal',
      shipping: 'Shipping',
      total: 'Total',
      quantity: 'Quantity',
      validation: {
        fillFields: 'Please fill: {{fields}}',
        phoneFormat: 'Phone must match +996XXXXXXXXX',
        selectRegion: 'Please select a delivery region',
        selectPayment: 'Please select a payment method',
      },
      errors: {
        orderCreate: 'An error occurred while creating the order',
      },
      yourOrder: 'Your Order',
    },
    catalog: {
      title: 'Furniture Catalog',
      titleB2B: 'B2B Furniture Catalog',
      b2bInfo: '🏢 Special B2B pricing & delivery terms',
      foundCount: '{{count}} items found',
      foundCountPlural: {
        one: '{{count}} item found',
        other: '{{count}} items found',
      },
      searchPlaceholder: 'Search products...',
      sort: 'Sort',
      sortName: 'By name',
      sortPriceAsc: 'Price: Low to High',
      sortPriceDesc: 'Price: High to Low',
      filters: 'Filters',
      filtersCount: 'Filters ({{count}})',
      reset: 'Reset',
      categories: 'Categories',
      categoryLabels: {
        vanities: 'Bathroom Vanities',
        cabinets: 'Tall Cabinets',
        'mirror-cabinets': 'Mirror Cabinets',
        'led-mirrors': 'LED Mirrors',
        mirrors: 'Mirrors',
        bathtubs: 'Bathtubs',
        showers: 'Shower Cabins',
        toilets: 'Toilets',
        sinks: 'Sinks',
        faucets: 'Faucets',
        'water-heaters': 'Water Heaters',
      },
      price: 'Price (KGS)',
      availability: 'Availability',
      onlyInStock: 'In stock only',
      notFoundTitle: 'No products found',
      notFoundSubtitle: 'Try adjusting search or filters',
      apply: 'Apply',
      products: 'Products',
    },
    // Room navigation
    rooms: {
      sectionTitle: 'Find furniture by room type',
      sectionSubtitle:
        'Choose a room and find the perfect solution for your interior',
      filterTitle: 'Room Type',
      clearFilter: 'Clear',
      bathroom: {
        title: 'Bathroom',
        short: 'Bathroom',
        description: 'Vanities, mirrors, showers, bathtubs and accessories',
      },
      toilet: {
        title: 'Toilet',
        short: 'Toilet',
        description: 'Toilets, sinks and compact furniture',
      },
      combined: {
        title: 'Combined Bathroom',
        short: 'Combined',
        description: 'Complete set for combined bathroom',
      },
    },
    // Set configurator
    setConfigurator: {
      title: 'Build Your Set',
      subtitle:
        'Choose a vanity, sink and mirror — get a discount on the entire set!',
      discountBanner:
        '{{discount}}% discount when purchasing a set of 2+ items!',
      steps: {
        vanity: 'Vanity',
        sink: 'Sink',
        mirror: 'Mirror',
      },
      stepHints: {
        vanity: 'Choose a bathroom vanity — the foundation of your set',
        sink: 'Add a sink that matches your vanity',
        mirror: 'Complete the look with a stylish mirror or mirror cabinet',
      },
      optional: '(optional)',
      yourSet: 'Your Set',
      notSelected: 'Not selected',
      subtotal: 'Subtotal',
      discount: 'Discount',
      total: 'Total',
      youSave: 'You save {{amount}} KGS',
      addSetToCart: 'Add set to cart',
      addedToCart: 'Set added to cart!',
      goToCart: 'Go to cart',
      createAnother: 'Build another',
      reset: 'Reset selection',
      back: 'Back',
      next: 'Next',
      noProducts: 'Products in this category are not available yet',
    },
    common: {
      loading: 'Loading...',
      error: 'Error',
      save: 'Save',
      close: 'Close',
    },
    header: {
      profile: 'Profile',
      myOrders: 'My Orders',
      applyB2B: 'Apply for B2B',
      register: 'Register',
    },
    footer: {
      catalog: 'Catalog',
      company: 'Company',
      support: 'Support',
      livingRoom: 'Living Room',
      bedroom: 'Bedroom',
      kitchen: 'Kitchen',
      office: 'Office',
      allProducts: 'All Products',
      about: 'About',
      delivery: 'Delivery & Payment',
      warranty: 'Warranty',
      contacts: 'Contacts',
      b2bCoop: 'B2B Cooperation',
      help: 'Customer Help',
      returns: 'Returns',
      privacy: 'Privacy Policy',
      terms: 'Terms of Use',
      faq: 'FAQ',
      businessBlock:
        'Premium furniture for home & business. Special conditions for B2B partners.',
      b2bPitch:
        '🏢 For Business: Special prices, deferred payment, personal manager.',
      b2bApply: 'Apply for B2B status',
      hours: 'Open 9:00–21:00',
      noDaysOff: 'No days off',
      rights: '© 2024 Furniture Excellence. All rights reserved.',
    },
    home: {
      welcomeChip: 'Welcome, {{name}}!',
      hero: {
        b2b: {
          title: 'Welcome to the B2B Portal',
          subtitle: 'Special pricing and terms for your business',
          primary: 'Go to B2B catalog',
          secondary: 'Quick order',
        },
        candidate: {
          title: 'Your application is under review',
          subtitle:
            'While we review your B2B request you can use the regular catalog',
          primary: 'View catalog',
          secondary: 'My profile',
        },
        default: {
          title: 'Premium furniture for home & office',
          subtitle:
            'Discover a collection of stylish, high-quality furniture. Special terms for businesses.',
          primary: 'View catalog',
          secondary: 'B2B partnership',
        },
      },
      features: {
        sectionTitle: {
          b2b: 'B2B Collaboration Advantages',
          default: 'Why Choose Us',
        },
        sectionSubtitle: {
          b2b: 'Exclusive conditions & service for business partners',
          default: 'We create an exceptional furniture shopping experience',
        },
        b2b: {
          pricing: {
            title: 'Special B2B Pricing',
            desc: 'Exclusive discounts & wholesale tiers for your business',
          },
          fastOrder: {
            title: 'Fast SKU Ordering',
            desc: 'Place orders in minutes with SKUs or lists',
          },
          manager: {
            title: 'Dedicated Manager',
            desc: 'Personalized assistance at every stage',
          },
          delivery: {
            title: 'Flexible Delivery Options',
            desc: 'Multiple address delivery & flexible timing',
          },
        },
        default: {
          quality: {
            title: 'Premium Quality',
            desc: 'Only top materials and vetted manufacturers',
          },
          delivery: {
            title: 'Fast Delivery',
            desc: 'We deliver nationwide at convenient times',
          },
          warranty: {
            title: 'Quality Guarantee',
            desc: 'Extended warranty and returns',
          },
          support: {
            title: '24/7 Support',
            desc: 'Our consultants are always ready to help',
          },
        },
      },
      cta: {
        title: 'Work with furniture?',
        subtitle:
          'Get access to special B2B pricing, dedicated manager and exclusive collaboration terms',
        buttonAuthenticated: 'Apply for B2B',
        buttonGuest: 'Register',
      },
      stats: {
        title: 'Your Capabilities',
        discount: {
          title: 'Catalog-wide Discount',
          desc: 'Your current tier: {{tier}}',
          more: 'More details',
        },
        terms: {
          title: 'Payment Terms',
          desc: 'Flexible payment options',
          settings: 'Settings',
        },
        support: {
          title: 'Support',
          desc: 'Dedicated manager',
          contact: 'Contact',
        },
      },
    },
    rates: {
      updatedAt: 'Rates as of {{date}}',
      refresh: 'Refresh',
      refreshing: 'Refreshing...',
      error: 'Failed to load rates',
      stale: 'Stale data',
      official: 'Official NBKR rates',
    },
  },
  ky: {
    nav: {
      home: 'Башкы',
      catalog: 'Каталог',
      cart: 'Себет',
      checkout: 'Төлөө',
      profile: 'Профиль',
      login: 'Кирүү',
      logout: 'Чыгуу',
      register: 'Катталуу',
      b2b: 'B2B Портал',
      admin: 'Админ',
      language: 'Тил',
      setConfigurator: 'Комплект түзүү',
    },
    auth: {
      email: 'Email',
      password: 'Сырсөз',
      rememberMe: 'Эстеп кал',
      forgotPassword: 'Сырсөз унутулдубу?',
      demoAccess: 'Демо кирүү',
      signIn: 'Кирүү',
      signUp: 'Катталуу',
      haveAccount: 'Катталгансызбы? Кирүү',
      noAccount: 'Аккаунт жокпу? Катталыңыз',
      name: 'Аты',
      lastName: 'Фамилия',
      passwordConfirm: 'Сырсөздү тастыктаңыз',
      registering: 'Катталууда...',
      loggingIn: 'Кирүүдө...',
      logoutSuccess: 'Сессия жабылды',
      registerSuccess: 'Катталуу ийгиликтүү',
      registerSuccessRedirect: 'Ийгиликтүү! Багытталууда...',
      useDemoOrCreds: 'Демо аккаунтту же өз реквизитиңизди колдонуңуз.',
      demoUser: 'Демо Колд.',
      demoB2B: 'Демо B2B',
      demoAdmin: 'Демо Админ',
      loginSuccess: 'Ийгиликтүү кирдиңиз',
      roleHelp:
        'Киргенден кийин: User → негизги, B2B → кеңейтилген баа, Admin → толук мүмкүнчүлүк.',
      allRequired: 'Бардык талаалар талап кылынат',
      emailInvalid: 'Туура эмес email форматы',
      passwordTooShort: 'Сырсөз кыска',
      passwordsMismatch: 'Сырсөздөр дал келген жок',
      registerError: 'Катталууда ката',
      createAccountHelp: 'Буйрутма берүү үчүн аккаунт түзүңүз.',
    },
    roles: {
      role_admin: 'Админ',
      role_b2c_customer: 'Кардар',
      role_b2b_candidate: 'B2B Каралууда',
      role_b2b_verified: 'B2B Кардар',
      role_guest: 'Конок',
    },
    product: {
      addToCart: 'Себетке кош',
      outOfStock: 'Жок',
      inStock: 'Бар',
      reviews: 'Пикирлер',
      rating: 'Баалоо',
      writeReview: 'Пикир жазуу',
      cancel: 'Жокко чыгаруу',
      submit: 'Жөнөт',
      buyNowShort: 'Сатып ал',
      addShort: 'Себетке',
      addLong: 'Себетке кош',
      quickView: 'Тез карап чыгуу',
      addFavorite: 'Тандалмаларга кош',
      removeFavorite: 'Тандалмадан өчүр',
      share: 'Бөлүшүү',
      rateProduct: 'Товарды баалоо',
      yourRating: 'Сиздин баа:',
      commentLabel: 'Пикириңиз (милдеттүү эмес)',
      commentPlaceholder: 'Товар жөнүндө ой-пикириңиз...',
      relatedProducts: 'Бул товар менен карашат',
      submitting: 'Жөнөтүлүүдө...',
      reviewSuccess: 'Пикириңиз үчүн рахмат!',
      reviewError: 'Пикир жөнөтүлбөй калды. Кийинчерээк кайталап көрүңүз.',
      loginRequired: 'Пикир калтыруу үчүн аккаунтка кириңиз',
      b2bMode: '🏢 B2B Режим - Бизнес үчүн атайын баалар',
      b2bPending: '⏳ B2B арызыңыз каралууда. Жакында байланышабыз.',
      recentlyViewed: 'Жакында көрүлгөндөр',
      clearHistory: 'Тарыхты тазалоо',
    },
    productMocks: {
      executiveChair: {
        name: 'Эргономикалык жетекчи креслосу',
        desc: 'Узак иштөөгө ылайыктуу ортопедиялык таянычы бар премиум кресло',
      },
      standingDesk: {
        name: 'Бийиктиги жөнгө салынуучу стол',
        desc: 'Бийиктигин электр менен жөнгө салуучу инновациялык стол',
      },
      modularSofa: {
        name: 'Жыйналышы мүмкүн диван',
        desc: 'Заманбап офис мейкиндиги үчүн модулдук диван',
      },
      conferenceTable: {
        name: '12 адамдык конференц-стол',
        desc: 'Кабель менеджменти бар чоң овальный конференц-стол',
      },
      ergonomicChair: {
        name: 'Эргономикалык жумуш креслосу',
        desc: 'Күнүмдүк ишке ылайыктуу желдетилген тор аркасы бар кресло',
      },
      mobileCabinet: {
        name: 'Жылма кулпуланма тумба',
        desc: 'Иштөө жайына ылайыктуу кичи мобилдик тумба',
      },
    },
    cart: {
      title: 'Себет',
      empty: 'Себет бош',
      total: 'Жалпы',
      proceed: 'Төлөөгө өтүү',
      quantity: 'Саны',
      goShopping: 'Сатып алууга өтүү',
      emptyTitle: 'Себетиңиз бош',
      emptySubtitle: 'Буйрутма берүү үчүн товар кошуңуз',
      orderSummary: 'Жыйынтык',
      itemsInCart: 'Себеттеги товарлар',
      promoCode: 'Промо код',
      enterCode: 'Код жазыңыз',
      apply: 'Колдонуу',
      applied: 'Колдонулду',
      discount10: '✓ 10% арзандатуу колдонулду',
      products: 'Товарлар',
      shipping: 'Жеткирүү',
      free: 'Акысыз',
      clear: 'Себетти тазалоо',
      itemTotal: 'Жыйынтык',
      checkout: 'Буйрутма берүү',
      loginAndCheckout: 'Кирип буйрутма берүү',
      continue: 'Улантуу',
      safePayment: 'Коопсуз төлөм',
      fastDelivery: 'Тез жеткирүү',
      variousPayments: 'Ар түрдүү төлөм ыкмалары',
      freeShippingThreshold: '🚚 50,000 үстүндө акысыз жеткирүү',
    },
    checkout: {
      title: 'Төлөө',
      placeOrder: 'Буйрутма берүү',
      summary: 'Кыскача маалымат',
      steps: {
        shipping: 'Жеткирүү',
        payment: 'Төлөм',
        confirmation: 'Ырастоо',
      },
      shippingInfo: 'Жеткирүү маалыматы',
      paymentMethod: 'Төлөм ыкмасы',
      orderConfirmation: 'Буйрутманы ырастоо',
      shippingAddress: 'Жеткирүү дареги',
      productsInOrder: 'Буйрутмадагы товарлар',
      address: 'Дарек',
      city: 'Шаар',
      phone: 'Телефон',
      firstName: 'Аты',
      lastName: 'Фамилия',
      email: 'Email',
      region: 'Регион',
      next: 'Кийинки',
      back: 'Артка',
      submitOrder: 'Буйрутма берүү',
      subtotal: 'Жыйынтык',
      shipping: 'Жеткирүү',
      total: 'Жалпы',
      quantity: 'Саны',
      validation: {
        fillFields: 'Толтуруңуз: {{fields}}',
        phoneFormat: 'Телефон форматы +996XXXXXXXXX болууга тийиш',
        selectRegion: 'Регион тандаңыз',
        selectPayment: 'Төлөм ыкмасын тандаңыз',
      },
      errors: {
        orderCreate: 'Буйрутма түзүүдө ката кетти',
      },
      yourOrder: 'Сиздин буйрутма',
    },
    catalog: {
      title: 'Эмерек каталогу',
      titleB2B: 'B2B Эмерек каталогу',
      b2bInfo: '🏢 B2B баалар жана жеткирүү шарттары',
      foundCount: '{{count}} товар табылды',
      foundCountPlural: {
        one: '{{count}} товар табылды',
        few: '{{count}} товар табылды',
        many: '{{count}} товар табылды',
        other: '{{count}} товар табылды',
      },
      searchPlaceholder: 'Товар издөө...',
      sort: 'Иреттөө',
      sortName: 'Аты боюнча',
      sortPriceAsc: 'Баасы: өсүүчү',
      sortPriceDesc: 'Баасы: төмөндөөнү',
      filters: 'Фильтрлер',
      filtersCount: 'Фильтрлер ({{count}})',
      reset: 'Тазалоо',
      categories: 'Категориялар',
      categoryLabels: {
        vanities: 'Ванна тумбалары',
        cabinets: 'Пеналдар',
        'mirror-cabinets': 'Күзгү шкафтар',
        'led-mirrors': 'LED күзгүлөр',
        mirrors: 'Күзгүлөр',
        bathtubs: 'Ваннлар',
        showers: 'Душ кабиналары',
        toilets: 'Унитаздар',
        sinks: 'Раковиналар',
        faucets: 'Смесительдер',
        'water-heaters': 'Суу ысыткычтар',
      },
      price: 'Баасы (сом)',
      availability: 'Бар-жогун',
      onlyInStock: 'Колодо бар',
      notFoundTitle: 'Товар табылган жок',
      notFoundSubtitle: 'Издөө же фильтр параметрлерин өзгөртүңүз',
      apply: 'Колдонуу',
      products: 'Товарлар',
    },
    // Бөлмө боюнча навигация
    rooms: {
      sectionTitle: 'Бөлмө түрү боюнча эмерек тандаңыз',
      sectionSubtitle: 'Бөлмө тандап, интерьериңизге ылайыктуу чечим табыңыз',
      filterTitle: 'Бөлмө түрү',
      clearFilter: 'Тазалоо',
      bathroom: {
        title: 'Ванна бөлмөсү',
        short: 'Ванна',
        description: 'Тумбалар, күзгүлөр, душтар жана аксессуарлар',
      },
      toilet: {
        title: 'Ажатай',
        short: 'Ажатай',
        description: 'Унитаздар, раковиналар жана кичине эмерек',
      },
      combined: {
        title: 'Бириккен санузел',
        short: 'Бириккен',
        description: 'Бириккен санузел үчүн толук комплект',
      },
    },
    // Комплект конфигуратору
    setConfigurator: {
      title: 'Өз комплектиңди түз',
      subtitle:
        'Тумба, раковина жана күзгү тандаңыз — бүт комплектке арзандатуу алыңыз!',
      discountBanner: '2+ товар комплектине {{discount}}% арзандатуу!',
      steps: {
        vanity: 'Тумба',
        sink: 'Раковина',
        mirror: 'Күзгү',
      },
      stepHints: {
        vanity: 'Ванна тумбасын тандаңыз — комплектиңиздин негизи',
        sink: 'Тумбага туура келген раковина кошуңуз',
        mirror: 'Стильдүү күзгү же күзгү шкафы менен толуктаңыз',
      },
      optional: '(кошумча)',
      yourSet: 'Сиздин комплект',
      notSelected: 'Тандалган эмес',
      subtotal: 'Сумма',
      discount: 'Арзандатуу',
      total: 'Жалпы',
      youSave: '{{amount}} сом үнөмдөйсүз',
      addSetToCart: 'Комплектти себетке кошуу',
      addedToCart: 'Комплект себетке кошулду!',
      goToCart: 'Себетке өтүү',
      createAnother: 'Дагы бирөө түзүү',
      reset: 'Тандоону тазалоо',
      back: 'Артка',
      next: 'Кийинки',
      noProducts: 'Бул категориядагы товарлар азырынча жок',
    },
    common: {
      loading: 'Жүктөлүүдө...',
      error: 'Ката',
      save: 'Сактоо',
      close: 'Жабуу',
    },
    header: {
      profile: 'Профиль',
      myOrders: 'Буйрутмаларым',
      applyB2B: 'B2B Арыз берүү',
      register: 'Катталуу',
    },
    footer: {
      catalog: 'Каталог',
      company: 'Компания',
      support: 'Колдоо',
      livingRoom: 'Гостиная',
      bedroom: 'Спальня',
      kitchen: 'Кухня',
      office: 'Офис',
      allProducts: 'Бардыгы',
      about: 'Компания жөнүндө',
      delivery: 'Жеткирүү & Төлөм',
      warranty: 'Гарантия',
      contacts: 'Байланыш',
      b2bCoop: 'B2B кызматташуу',
      help: 'Жардам',
      returns: 'Кайтаруу',
      privacy: 'Купуялык',
      terms: 'Шарттар',
      faq: 'FAQ',
      businessBlock:
        'Үй жана бизнес үчүн премиум эмерек. B2B өнөктөштөр үчүн шарттар.',
      b2bPitch: '🏢 Бизнес үчүн: Атайын баа, мөөнөттүү төлөм, менеджер.',
      b2bApply: 'B2B статусуна арыз',
      hours: '9:00–21:00 иштейбиз',
      noDaysOff: 'Дем алышсыз',
      rights: '© 2024 Furniture Excellence. Бардык укуктар корголгон.',
    },
    home: {
      welcomeChip: 'Кош келиңиз, {{name}}!',
      hero: {
        b2b: {
          title: 'B2B порталга кош келиңиз',
          subtitle: 'Бизнесиңиз үчүн атайын баалар жана шарттар',
          primary: 'B2B каталогго өтүү',
          secondary: 'Ыкчам заказ',
        },
        candidate: {
          title: 'Арыз каралууда',
          subtitle:
            'B2B арызыңыз каралып жатканда кадимки каталогду колдоно берсеңиз болот',
          primary: 'Каталогду көрүү',
          secondary: 'Профилим',
        },
        default: {
          title: 'Үй жана офис үчүн премиум эмерек',
          subtitle:
            'Сапаттуу жана кооз эмерек коллекциясын табыңыз. Бизнес үчүн шарттар.',
          primary: 'Каталогду көрүү',
          secondary: 'B2B кызматташуу',
        },
      },
      features: {
        sectionTitle: {
          b2b: 'B2B артыкчылыктары',
          default: 'Эмне үчүн бизди тандашат',
        },
        sectionSubtitle: {
          b2b: 'Бизнес өнөктөштөр үчүн эксклюзивдүү шарттар',
          default: 'Биз эмерек сатып алууну өзгөчө тажрыйбага айлантабыз',
        },
        b2b: {
          pricing: {
            title: 'B2B баалар',
            desc: 'Эксклюзивдүү арзандатуулар жана дүң баалар',
          },
          fastOrder: {
            title: 'SKU аркылуу ыкчам заказ',
            desc: 'SKU же тизмелер менен бир нече мүнөттө заказ',
          },
          manager: {
            title: 'Жеке менеджер',
            desc: 'Ар бир этапта колдоо жана персоналдаштыруу',
          },
          delivery: {
            title: 'Туура шарттагы жеткирүү',
            desc: 'Бир нече дарекке жеткирүү жана ийкемдүү убакыт',
          },
        },
        default: {
          quality: {
            title: 'Премиум сапат',
            desc: 'Мыкты материалдар жана текшерилген өндүрүүчүлөр',
          },
          delivery: {
            title: 'Ыкчам жеткирүү',
            desc: 'Бүт өлкө боюнча ыңгайлуу учурда жеткирүү',
          },
          warranty: {
            title: 'Сапат кепилдиги',
            desc: 'Кеңейтилген кепилдик жана кайтаруу мүмкүнчүлүгү',
          },
          support: { title: '24/7 Колдоо', desc: 'Консультанттар дайыма даяр' },
        },
      },
      cta: {
        title: 'Эмерек менен иштейсизби?',
        subtitle:
          'B2B бааларга, жеке менеджерге жана эксклюзивдүү шарттарга мүмкүнчүлүк алыңыз',
        buttonAuthenticated: 'B2B арыз берүү',
        buttonGuest: 'Катталуу',
      },
      stats: {
        title: 'Мүмкүнчүлүктөрүңүз',
        discount: {
          title: 'Каталог боюнча арзандатуу',
          desc: 'Учурдагы деңгээлиңиз: {{tier}}',
          more: 'Көбүрөөк',
        },
        terms: {
          title: 'Төлөм шарттары',
          desc: 'Ийкемдүү төлөм ыкмалары',
          settings: 'Баптоолор',
        },
        support: {
          title: 'Колдоо',
          desc: 'Жеке менеджер',
          contact: 'Байланыш',
        },
      },
    },
    rates: {
      updatedAt: 'Курс күнү: {{date}}',
      refresh: 'Жаңыртуу',
      refreshing: 'Жаңыртууда...',
      error: 'Курстар жүктөлгөн жок',
      stale: 'Эски маалымат',
      official: 'Улуттук банктын расмий курстары',
    },
  },
};

export const flatten = (obj, prefix = '', result = {}) => {
  Object.entries(obj).forEach(([key, value]) => {
    const fullKey = prefix ? `${prefix}.${key}` : key;
    if (typeof value === 'object' && value !== null) {
      flatten(value, fullKey, result);
    } else {
      result[fullKey] = value;
    }
  });
  return result;
};

export const flatDictionaries = {
  ru: flatten(dictionaries.ru),
  en: flatten(dictionaries.en),
  ky: flatten(dictionaries.ky),
};
